export class JiraExport {
  constructor(
    private readonly url: string,
    private readonly jiraConsumerKey: string | null,
    private readonly jiraPublicKey: string | null,
    private readonly jiraProjectKey: string | null,
    private readonly jiraIssuetypeKey: string | null,
    private readonly jiraAuthorizationUrl: string | null,
    private readonly jiraAccessToken: string | null
  ) {}

  getJiraUrl() {
    return this.url;
  }

  getJiraConsumerKey() {
    return this.jiraConsumerKey;
  }

  getJiraPublicKey() {
    return this.jiraPublicKey;
  }

  getJiraProjectKey() {
    return this.jiraProjectKey;
  }

  getJiraIssuetypeKey() {
    return this.jiraIssuetypeKey;
  }

  getJiraAuthorizationUrl() {
    return this.jiraAuthorizationUrl;
  }

  getJiraAccessToken() {
    return this.jiraAccessToken;
  }
}
